import { FC } from 'react';
const defaultTips = "Bybit's NFT marketplace";
import ComplianceElement from '@/components/ComplianceElement';
import { useUserStore } from '@/store/useUser';
import { complianceHide } from '@/utils/complianceHelpers';
import XSensors from '@/utils/skynet';
/**
 * Bybit's NFT marketplace nft市场跳转链接组件
 * @param content 整体文字包含{type}
 * @param linkContent 待替换{}的内容
 * @returns reactNode
 */
export const AvatarNFTLink: FC<{
  content: string;
  linkContent: string;
}> = ({ content, linkContent }) => {
  const { complianceConfig } = useUserStore();
  const handleClick = () => {
    XSensors.track('USModifyavatarPageNFTmarketClick', {
      // nft_user_type: 2, // 1无nft 2有nft
    });
  };
  const msg =
    complianceHide(complianceConfig.NFT) && content?.includes?.('{NFT}')
      ? 'Choose an avatar to personalize your account.'
      : content;
  const [p1, p2] = msg?.split?.('{NFT}') || '';
  const href = location.origin + `/${localStorage.BYBIT_LANG_KEY}/nft/`;
  return (
    <>
      {p1}
      <ComplianceElement config={complianceConfig.NFT}>
        <>
          <span onClick={handleClick}>
            <span
              className="link_a"
              onClick={() => (window.location.href = href)}
            >
              &nbsp;
              {linkContent || defaultTips}
              &nbsp;
            </span>
          </span>
          {p2}
        </>
      </ComplianceElement>
    </>
  );
};
